<template>
<zm-dialog
  class="enjoy-tip-dialog"
  :visible.sync="visible"
  width="1300px"
  append-to-body
>
  <!-- Set the default height for the container on mobile. After the video is loaded, the height of the container is determined by the video. -->
  <div
    class="video-container"
    v-loading="!this.player"
    :style="($context.is.desktop || player) ? {} : { height: '200px' }"
    @click="pauseVideo"
  >
    <img
        v-show="!isVideoPlaying && this.player"
        class="video-control play-squircle-fill"
        src="../../assets/plans/play.svg"
        @click="changePlayState"
      />
    <zm-player
      :src="VIDEO_SOURCE"
      :poster="VIDEO_POSTER"
      @ready="handleVideoElReady"
    />
  </div>
  <div class="text-description">
    <img
      src="../../assets/plans/close.svg"
      class="close-btn"
      @click="handleCloseDialog"
      />
    <div class="tip-header">
      <img class="companion-logo" src="../../assets/plans/ai-companion.svg" alt="">
      {{ $t("companionModalTitle") }}
      <img class="add-on-new" src="../../assets/plans/addon_new.svg" />
    </div>
    <div class="tip-content">
      {{$t("companionModalDesc") }}
    </div>
    <div class="tip-list">
      <p class="tip-list__title">{{ $t('marketing.enjoy_companion.top_features') }}</p>
      <div v-for="item in tipList" :key="item" class="tip-list-item">
        <img src="../../assets/plans/check.svg" alt="">
        <div>{{ item }}</div>
      </div>
    </div>
    <div class="divider"></div>
    <p class="tips-bottom">{{ $t('marketing.enjoy_companion.more_feature_come') }}</p>
    <p class="legal-terms bottom-text">{{ $t('marketing.enjoy_companion.legal_terms') }}</p>
  </div>
</zm-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { ConfirmComponent } from '../common/service-dialog/confirm';

const AICompanionVideo = window.newBillingConfig?.AICompanionVideo;

export default {
name: 'CompanionBanner',
mixins: [ConfirmComponent],
data () {
  return {
    VIDEO_SOURCE: AICompanionVideo,
    VIDEO_POSTER: require('../../assets/plans/companion-poster.jpg'),
    visible: false,
    player: null,
    tipList: this.$t('companionModalContent')?.split(';') || [],
    isVideoPlaying: false,
    videoStates: ['play', 'playing', 'pause', 'ended', 'error']
  };
},
computed: {
  ...mapState({
    billingConf: state => state.billingConf,
    isLogin: state => state.isLogin
  }),
  isPaidAccount () {
    return this.isLogin && !this.billingConf.isFreeAccount;
  }
},
mounted () {
},
beforeDestroy () {
  this.removeVideoListener();
},
methods: {
  handleCloseDialog () {
    this.visible = false;
    this.player?.pause?.();
  },
  handleVideoElReady (player) {
    this.player = player;
    this.registerVideoEvent();
  },
  changePlayState () {
    const method = this.isVideoPlaying ? 'pause' : 'play';
    this.player[method]?.();
  },
  pauseVideo () {
    this.isVideoPlaying && this.player.pause();
  },
  registerVideoEvent () {
    const videoElement = document.querySelector('.video-container video');
    this.videoStates.forEach(state => videoElement?.addEventListener(state, this.onVideoStateChange));
  },
  removeVideoListener () {
    const videoElement = document.querySelector('.video-container video');
    this.videoStates.forEach(state => videoElement?.removeEventListener(state, this.onVideoStateChange));
    this.player = null;
  },
  onVideoStateChange ({ type }) {
    this.isVideoPlaying = type?.includes('play');
  }
},
};
</script>

<style lang="scss">
@import '@/styles/responsive.scss';

$font-size: 14px;

.enjoy-tip-dialog {
  .zm-dialog {
    padding: 0;
    border-radius: 8px;
    border: 0;
    overflow: hidden;
    @include media(mobile) {
      $verticalMargin: 7vh;
      margin-top: $verticalMargin !important;
      margin-bottom: 0 !important;
      height: calc(100% - #{$verticalMargin} * 2) !important;
    }
    @include media(tablet) {
      $verticalMargin: 15vh;
      margin-top: $verticalMargin !important;
      margin-bottom: 0 !important;
      height: calc(100% - #{$verticalMargin} * 2) !important;
    }
    @include media(mobile, tablet) {
      $dialogWidth: calc(100% - 24px);
      width: $dialogWidth !important;
      min-width: $dialogWidth !important;
      padding-top: 40px !important;
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }

    &__header {
      display: none;
      @include media(mobile, tablet) {
        flex-shrink: 0;
        width: 100%;
      }
    }

    &__body {
      display: flex;
      @include media(mobile, tablet) {
        flex-grow: 1;
        flex-direction: column;
        width: 100%;
        overflow: auto;
      }

      .video-container {
        width: 800px;
        height: auto;
        position: relative;
        @include media(mobile, tablet) {
          flex-shrink: 0;
          width: 100%;
          height: auto;
        }
        .video-player-layout {
          height: 100%;
        }

        @include media(mobile) {
          .video-player-layout {
            height: 160px !important;
          }
        }

        @include media(tablet) {
          .video-player-layout {
            height: 300px !important;
          }
        }

        .video-control {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 62px;
          height: 62px;
          transform: translate(-50%, -50%);
          cursor: pointer;
          z-index: 1;

          i {
            font-size: 40px;
            color: #00053d;
          }
        }

        video {
          width: 100%;
          height: 100%;
          // object-fit: cover;
          pointer-events: none;
        }

        .video-player-wrapper {
          height: 100% !important;

          .vjs-control-bar {
            display: none;
          }
        }
      }

      .video-js {
        border-radius: 12px 0 0 12px;

        @include media(mobile, tablet) {
          border-radius: 6px;
        }
      }

      .text-description {
        width: 500px;
        padding: 32px 32px 16px;
        display: flex;
        flex-direction: column;
        @include media(mobile, tablet) {
          width: 100%;
          padding: 24px 0;
        }

        .close-btn {
          position: absolute;
          top: 24px;
          right: 24px;
          cursor: pointer;
          @include media(mobile, tablet) {
            top: 14px;
            right: 14px;
            width: 12px;
            height: auto;
          }
        }

        .tip-header {
          display: flex;
          align-items: center;
          color: #00053D;
          font-size: 22px;
          font-weight: 700;
          @include media(mobile, tablet) {
            font-size: 18px;
          }

          .companion-logo {
            width: 44px;
            height: 44px;
            margin-right: 16px;
            @include media(mobile, tablet) {
              margin-right: 8px;
              width: 32px;
              height: 32px;
            }
          }

          .add-on-new {
            margin-left: 8px;
            width: 45px;
            height: 20px;
            @include media(mobile, tablet) {
              margin-left: 4px;
              width: auto;
              height: 16px;
            }
          }

        }

        .tip-content {
          font-size: 14px;
          color: #666487;
          font-weight: 400;
          margin: 16px 0;
          line-height: 21px;
          font-family: Almaden Sans;
        }

        .tip-list {
          &__title {
            color: var(--day-foreground-foreground-strong, #00031F);
            /* label/M (M) */
            font-family: Almaden Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%; /* 19.2px */
            height: 27px;
          }
          &-item {
            display: flex;
            align-items: flex-start;
            line-height: 24px;
            color: #00031F;
            font-size: 16px;
            font-weight: 400;
            margin-top: 8px;

            > img {
              margin-right: 3px;
            }
          }
        }
        .divider {
          width: 436px;
          height: 1px;
          background: #E0E0E6;
          margin: 16px 0;
          @include media(mobile, tablet) {
            width: 100%;
          }
        }
        .tips-bottom {
          color: var(--day-foreground-foreground-strong, #00031F);
          /* body/LF — S (R) */
          font-family: Almaden Sans;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%; /* 21px */
          padding-top: 4px;
        }
        .legal-terms {
          color: var(--neutral-neutral-08, #515079);
          /* body/LF — XS (R) */
          font-family: Almaden Sans;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%; /* 18px */
        }
        .bottom-text {
          margin-top: auto;
        }
      }
    }
  }
}
</style>
